import { combineEpics } from 'redux-observable';
import { combineLatest, filter, ignoreElements, map, mapTo, switchMap, tap } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { createEpic$ } from 'lib/store';
import { writeLocalThemeVariant } from 'lib/styles';
import { configureAxios } from 'services/axios';
import { SystemAction, systemConfig, systemInitialized } from './actions';

const systemConfigEpic$ = createEpic$(({ action$, config$ }) =>
  action$.pipe(
    filter(isOfType(SystemAction.Ready)),
    switchMap(() => combineLatest([config$]).pipe(map(([config]) => systemConfig(config)))),
  ),
);

const systemInitializedEpic$ = createEpic$(({ action$ }) =>
  action$.pipe(
    filter(isOfType(SystemAction.Config)),
    map(action => action.payload),
    tap(config => configureAxios(config.api.baseUrl)),
    mapTo(systemInitialized()),
  ),
);

const systemThemeEpic$ = createEpic$(({ action$ }) =>
  action$.pipe(
    filter(isOfType(SystemAction.Theme)),
    map(action => action.payload),
    tap(writeLocalThemeVariant),
    ignoreElements(),
  ),
);

export default combineEpics(systemConfigEpic$, systemInitializedEpic$, systemThemeEpic$);
